import useIsImageDark from 'hooks/useIsImageDark';
import useIsColorDark from 'hooks/useIsColorDark';

const useIsImageColorDark = (image, color) => {
  return { imageDark: useIsImageDark(image), colorDark: useIsColorDark(color) };
};

export default useIsImageColorDark;
